export const quillOfTheCordant = `
{{Thus speaks Cordant Prime, the great communicator[[x,x,x]]}}
{{I have convinced many by my words[[x,x,x]]}}
{{But highly effecting communication requires great discipline and control.[[100,0,x]]}}
{{We have stolen the[[x,x,x]]}} {{Scepter of the Warden[[100,100,x]]<<Scepter of the Warden>>}} {{and will use it to vanquish its master[[100,100,x]]}}
`;
